var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetUsersCreatedInLastDaysQuery } from "@/services/usersApi";
var NewUsersPage = function () {
    var _a = useGetUsersCreatedInLastDaysQuery(), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    if (isLoading)
        return _jsx("p", { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." });
    if (error)
        return _jsx("p", { children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0434\u0430\u043D\u043D\u044B\u0445" });
    return (_jsxs("div", __assign({ className: "NewUsers", style: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginLeft: "100px",
            height: "100%",
        } }, { children: [_jsxs("p", __assign({ style: { fontSize: "40px" } }, { children: [data === null || data === void 0 ? void 0 : data.count, " \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 3 \u0434\u043D\u044F"] })), data === null || data === void 0 ? void 0 : data.users.map(function (user) { return (_jsx("p", { children: user.login }, user.id)); })] })));
};
export default NewUsersPage;
